import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';

/**
 * Reusable back button component
 * Used across all pages for consistent navigation
 */
export const BackButton = ({ 
  to = null, 
  onClick = null,
  className = '',
  iconClassName = 'w-5 h-5 text-navy'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={handleClick}
      className={className}
      data-testid="back-button"
    >
      <ArrowLeft className={iconClassName} />
    </Button>
  );
};

export default BackButton;
